document.addEventListener("DOMContentLoaded", function(){
  //console.log('Collection filters initialized');

  function encodeFilterValue(value) {
    // Convert spaces to %20 for SearchSpring filtering
    return value.trim().replace(/\s+/g, '%20');
  }

  function decodeFilterValue(value) {
    // Decode + back to spaces and trim
    return value.replace(/\+/g, ' ').trim();
  }

  function updateUrlHash(filterTag, isSelected) {
    const currentHash = window.location.hash;
    
    // Use only lowercase version for filtering
    const filterTagLower = filterTag.toLowerCase();
    const filterString = `filter:ss_subcollection_filter:${encodeFilterValue(filterTagLower)}`;
    
    let newHash;
    if (isSelected) {
      const cleanHash = currentHash.replace(/\/?filter:ss_subcollection_filter:[^/]+/g, '');
      
      if (!cleanHash || cleanHash === '#') {
        newHash = `#/${filterString}`;
      } else {
        newHash = `${cleanHash}/${filterString}`;
      }
    } else {
      newHash = currentHash.replace(`/${filterString}`, '').replace(filterString, '');
      newHash = newHash.replace(/\/+/g, '/');
      if (newHash === '#/') {
        newHash = '#';
      }
    }

    window.location.hash = newHash;
  }

  $(".subcollection-bar__subcollection").on("click", "a:not(.opens-new-window)", function (event) {
    // Get the filter tag from data attribute (which has + from Liquid url_encode)
    const filterTag = decodeFilterValue($(event.currentTarget).attr('data-filter-tag'));
    event.preventDefault();
    const $link = $(event.currentTarget);

    $('.subcollection-bar__subcollection a').removeClass('selected');
    $link.toggleClass('selected');

    const isSelected = $link.hasClass('selected');
    
    updateUrlHash(filterTag, isSelected);
    
    if (isSelected) {
      const productsSection = $('.collection-grid');
      
      $('body,html').animate({
        scrollTop: productsSection.offset().top - 250
      }, 0);
    }
  });

  $(document).on('click', '.ss__list__link:not([href*="filter:ss_subcollection_filter:"])', function(event) {
    const $link = $(event.currentTarget);
    const currentHash = window.location.hash;
    
    // If there are any subcollection filters, preserve them
    if (currentHash && currentHash.includes('filter:ss_subcollection_filter:')) {
      const subcollectionFilters = currentHash.match(/filter:ss_subcollection_filter:[^/]+/g);
      if (subcollectionFilters) {
        event.preventDefault();

        const newFilter = $link.attr('href').split('#')[1];
        let newHash = newFilter;
        subcollectionFilters.forEach(filter => {
          newHash += `/${filter}`;
        });
        
        window.location.hash = newHash;
      }
    }
  });

  // Check if URL has SearchSpring filters and update UI accordingly
  const hash = window.location.hash;
  if (hash && hash.includes('filter:ss_subcollection_filter:')) {
    const filterMatches = hash.match(/filter:ss_subcollection_filter:([^/]+)/g);
    if (filterMatches) {
      filterMatches.forEach(match => {
        const filterMatch = match.match(/filter:ss_subcollection_filter:([^/]+)/);
        if (filterMatch) {
          const encodedValue = filterMatch[1];
          const decodedValue = decodeFilterValue(encodedValue);
          
          // Find matching elements by comparing with lowercase values
          $('.subcollection-bar__subcollection a').each(function() {
            const elementFilterTagLower = decodeFilterValue($(this).attr('data-filter-tag'));
            if (elementFilterTagLower === decodedValue) {
              $(this).addClass('selected');
            }
          });
        }
      });
    }
  }
}); 